<mat-slide-toggle
  id="mat-slide-toggle-id"
  [labelPosition]="labelPosition"
  [ngClass]="[customClassName]"
  [(ngModel)]="value"
  [disabled]="disabled"
>
  <ng-container *ngIf="isCustomTemplate; else defaultTemplateRef">
    <ng-content></ng-content>
  </ng-container>
  <ng-template #defaultTemplateRef>
    <app-text id="mat-slide-toggle-label-id" [textStyleType]="textStyleType">
      {{ label }}
    </app-text>
  </ng-template>
</mat-slide-toggle>
